import { useState } from 'react'
import { Typography, Stack, Box, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import RolePlayChat from './RolePlayChat'
import PublicRolePlayInteractionCard from 'components/molecules/rolePlay/PublicRolePlayInteractionCard'
import { ROLE_PLAY_TYPES } from 'services/constants'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'services/amplitudeTracking'
import { useLocation } from 'react-router-dom'
import RolePlayRTVICall from './RolePlayRTVICall'

const PublicRolePlayCard = ({
  rolePlay,
  setCompleted,
  setCompletedRolePlay,
  started,
  setStarted
}) => {
  const location = useLocation()
  const { t } = useTranslation()
  const theme = useTheme()
  const [practiceType, setPracticeType] = useState('')

  const RolePlayInteractionBox = () => (
    <PublicRolePlayInteractionCard
      rolePlay={rolePlay}
      buttonText={
        practiceType === ROLE_PLAY_TYPES.LIVE_CALL
          ? t('rolePlay.startLiveCall')
          : t('rolePlay.startChat')
      }
      onButtonClick={() => {
        setStarted(true)
        trackEvent('Start Role Play', { location: location.pathname })
      }}
      practiceType={practiceType}
      setPracticeType={setPracticeType}
    />
  )

  return (
    <>
      {rolePlay && (
        <Grid container spacing={20}>
          <Grid size={12} sx={theme.publicRolePlay.mobileOnly}>
            {!started && <RolePlayInteractionBox />}
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 7 }}>
            <Stack spacing={4}>
              <Typography
                variant='h1'
                id='rolePlayHeading'
                sx={theme.publicRolePlay.scenario.title}>
                {rolePlay.title}
              </Typography>
              <Box
                sx={{ fontFamily: 'Poppins' }}
                dangerouslySetInnerHTML={{
                  __html: rolePlay.context?.publicHtml || rolePlay.context?.html
                }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 5 }}>
            {started && practiceType === ROLE_PLAY_TYPES.TEXT_CHAT && (
              <RolePlayChat
                rolePlay={rolePlay}
                isStarted={started}
                setIsStarted={setStarted}
                isCompleted={false}
                setIsCompleted={setCompleted}
                setUserCompletedRolePlay={setCompletedRolePlay}
                isPublicRolePlay={true}
              />
            )}

            {started && practiceType === ROLE_PLAY_TYPES.LIVE_CALL && (
              <RolePlayRTVICall
                rolePlay={rolePlay}
                started={started}
                setStarted={setStarted}
                completed={false}
                setCompleted={setCompleted}
                setUserCompletedRolePlay={setCompletedRolePlay}
                isPublicRolePlay={true}
              />
            )}
            {!started && <RolePlayInteractionBox />}
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default PublicRolePlayCard
